import { render } from "./FilterDistributor.vue?vue&type=template&id=2b79cb89"
import script from "./FilterDistributor.vue?vue&type=script&lang=js"
export * from "./FilterDistributor.vue?vue&type=script&lang=js"
script.render = render

export default script